import React, { useEffect, useState } from "react";

import { Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "./../../hooks/useDataFetch";
import { useDegrees } from "./../../hooks/useDegrees";
import CurrencyInput from "react-currency-input-field";
import { toast } from "react-toastify";
import { isEndDateAfterStartDate, isInteger } from "../utils";

const Annualy = () => {
  const [yearFilter, setYearFilter] = useState(
    new Date().getFullYear().toString()
  );
  const [items, setItems] = useState([]);

  const { getData, patchData, postData, invalidateQuery } = useDataFetch();

  const { degrees: datadegreeList } = useDegrees(yearFilter);

  const { data } = getData(["cost-annuals"], "/cost-annuals", {
    enabled: true,
  });

  const { mutate: createCostAnnualy, isLoading: isCreateLoading } = postData(
    "/cost-annuals",
    {},
    {},
    {
      onSuccess: (data) => {
        const result = data?.data?.data;
        setItems((prev) => {
          const index = prev.findIndex(
            (item) =>
              result.degree_id == item.degree_id && result.year == item.year
          );
          prev[index].id = result.id;
          return [...prev];
        });
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: updateCostAnnualy, isLoading: isUpdateLoading } = patchData(
    "/cost-annuals",
    {},
    {
      onSuccess: (data) => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  useEffect(() => {
    if (datadegreeList?.length > 0) {
      let items = [];
      for (const element of datadegreeList) {
        let annualy;
        if (data) {
          annualy = data?.data?.find(
            (e) => element.id == e.degree_id && e.year == yearFilter
          );
        }
        items.push({
          id: annualy ? annualy.id : null,
          degree_name: `${element?.level} ${element?.degree}`,
          degree_id: element?.id,
          year: yearFilter,
          registration_value: annualy ? annualy.registration_value : null,
          sure_value: annualy ? annualy.sure_value : null,
          start_date: annualy ? annualy.start_date : null,
          end_date: annualy ? annualy.end_date : null,
        });
      }
      setItems(items);
    }
  }, [data, datadegreeList, yearFilter]);

  const save = (e) => {
    if (!e.registration_value || !isInteger(e.registration_value)) {
      toast.error("El valor de la matricula no es correcto ");
      return;
    }

    if (!e.sure_value || !isInteger(e.sure_value)) {
      toast.error("El valor del seguro no es correcto ");
      return;
    }
    if (e.start_date && e.end_date) {
      const valid_date = isEndDateAfterStartDate(e.start_date, e.end_date);
      if (!valid_date) {
        toast.error("Las fechas no son correctas");
        return;
      }
    } else {
      toast.error("Las fechas son requeridas");
      return;
    }

    if (e?.id) {
      updateCostAnnualy(e);
    } else {
      createCostAnnualy(e);
    }
  };

  return (
    <Tab.Container defaultActiveKey="all">
      <div className="d-flex">
        <select
          className="form-control mb-3"
          onChange={(e) => setYearFilter(e.target.value)}
          value={yearFilter}
          style={{ width: 100 }}
        >
          {[2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div className="table-responsive">
        <table className="table card-table display dataTablesCard dataTable no-footer">
          <thead>
            <tr>
              <th>Año</th>
              <th>Grado</th>
              <th>Matricula</th>
              <th>Seguro</th>
              <th>Fecha inicial</th>
              <th>Fecha final</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items?.map((e) => (
              <tr key={e.month}>
                <td>{e.year}</td>
                <td>{e.degree_name}</td>
                <td>
                  <CurrencyInput
                    value={e.registration_value}
                    className="form-control"
                    decimalsLimit={0}
                    decimalSeparator=","
                    groupSeparator="."
                    onValueChange={(value, name, values) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.degree_id == e.degree_id
                        );
                        prev[index].registration_value = value;

                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <CurrencyInput
                    value={e.sure_value}
                    className="form-control"
                    decimalsLimit={0}
                    decimalSeparator=","
                    groupSeparator="."
                    onValueChange={(value, name, values) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.degree_id == e.degree_id
                        );
                        prev[index].sure_value = value;

                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.start_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.degree_id == e.degree_id
                        );
                        prev[index].start_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.end_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.degree_id == e.degree_id
                        );
                        prev[index].end_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <Button
                    type="button"
                    onClick={() => save(e)}
                    disabled={isCreateLoading || isUpdateLoading}
                  >
                    Guardar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Tab.Container>
  );
};

export default Annualy;
